import * as React from 'react'
import { config } from 'react-awesome-styled-grid'
import styled from 'styled-components'
import { colors } from '@components/shared/colors'
import type { TagInfoType } from '../../models/Tag'
import Link from 'next/link'
import { GoodSansB3 } from '@components/shared/typography'

type TagLinkRowPropsType = {
  id: string,
  small?: boolean,
  tags: TagInfoType[]
}
export function TagLinksRow (props: TagLinkRowPropsType): React.ReactNode {
  return (
    <Container>
      {props.tags.map((tag: TagInfoType, index: number): React.ReactNode => {
        return <TagLink passHref={true} href={tag.slug} key={`tag-link-${props.id}-${index}`}>{tag.title}</TagLink>
      })}
    </Container>
  )
}

const Container = styled.div<any>`
  color: ${colors.white70};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  max-width: calc(100vw - 40px);
  ${(props: any): any => config(props).media.sm`
    max-width: calc(100vw - 240px);
  `}
  ${(props: any): any => config(props).media.md`
    max-width: unset;
    flex-wrap: wrap;
    display: flex;
  `}
`
const TagLink = styled(Link)<any>`
  ${GoodSansB3};
  line-height: 130%;
  color: ${colors.white70};
  :not(:last-child):after {
    content: ',';
    margin-right: .25rem;
  }
`
